// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if ({"wp-content_themes_tessellate_assets_js_maps_js":1,"wp-content_themes_tessellate_assets_js_question_js":1,"wp-content_themes_tessellate_assets_js_accessibility_js":1,"wp-content_themes_tessellate_assets_js_swiper_js":1}[chunkId]) return "wp-content/themes/tessellate/assets/js/javascript/" + chunkId + ".js";
	// return url for filenames based on template
	return undefined;
};